import React from 'react';

// WORDPRESS components
import {
  Button,
  Flex,
  FlexItem,
  FlexBlock,
  Spinner,
  __experimentalRadio as Radio,
  __experimentalRadioGroup as RadioGroup,
} from '@wordpress/components';

// THIRD PARTY components
// STRIPE components
import { Elements } from '@stripe/react-stripe-js';
import * as axios from 'axios';
import { loadStripe } from '@stripe/stripe-js';
const stripePromise = loadStripe(CONFIG.stripeKey);

/**
 * LOCAL COMPONENTS
 */
// STEPS MODULES
import CompositionsList from './components/CompositionsList';
import Account from './components/Account';
import PaymentForm from './components/PaymentForm';
import Order from './components/Order';
import CouponForm from './components/CouponForm';
// aditional components
import StepTitle from './components/elements/StepTitle';

// DASHBOARD local CSS
import './css/dashboard.css';

// LOCAL scripts
import { getAuthToken, getAccessToken } from '../shared/utils';

// THIRD PARTY libraries
import findIndex from 'lodash/findIndex';

// CONSTANTS
// BACKEND path
const backend = axios.create({
  baseURL: CONFIG.backendHost + '/' + CONFIG.widgetId,
});
let wp = {};
// console.log('Dashboard for Widget:', CONFIG.widgetId);
// SUBSCRIPTION statuses
const SubscriptionStatus = {
  INEXISTENT: 0,
  ACTIVE: 1,
  PAST_DUE: 2,
  PENDING: 3,
};

/**
 * DASHBOARD COMPONENT CLASS
 */
class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    // STATE
    this.state = {
      siteName: window.location.hostname,
      // local vars
      loading: false,
      accountDataLoaded: false,
      // user details
      email: null,
      profile: {
        interval: null,
        card: null,
        paymentMethodId: null,
      },
      prices: { month: null, year: null },
      invoices: [],
      // published blocks
      publishedComps: [],
      // navigation properties
      currentStep: '', // "dashboard", "plans", "card", "order"
      stepsArray: [],
      selectedPlan: 'month',
      coupon: {},
      // widget details
      widgetMeta: {},
    };

    // FUNCTIONS
    this.setStatePlan = this.setStatePlan.bind(this);
    this.setStateSubcrStatus = this.setStateSubcrStatus.bind(this);
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  }

  /**
   * MOUNT METHOD
   */
  async componentDidMount() {
    // console.log('Dashboard Comp didMount:', this.state.currentStep);
    // add dashboard step anyway
    // this.goToStep('dashboard');

    // READ DATA about the CURRENT USER
    // show spinner
    this.setState({ loading: true });

    // get acess token
    let data = await getAccessToken(true);
    Widgetic.auth.token(data.token);

    // read WP USER
    wp = require('../shared/wpapi');
    let currentUser;
    try {
      currentUser = await wp.currentUser();
      // console.log('found currentUser:', currentUser);
    } catch (e) {
      console.log('WP error', e);
    }
    const { user_email } = currentUser.data;
    const user_full_name = currentUser.data.display_name;
    // this.setState({ email: user_email });

    // read SUBSCRIPTION status, PLAN, CARD details
    // get auth token
    const { authToken } = await getAuthToken();
    const headers = { Authorization: `Bearer ${authToken}` };

    // call backend
    try {
      const results = await Promise.all([
        backend.get('', { headers }), // subscription endpoint
      ]);
      // console.log('Dashboard backend results:\n', results);

      // read SUBSCRIPTION details
      // read card details from subscription
      const cardDetails = results[0].data.card || {};
      if (results[0].data.customerName)
        cardDetails.holderName = results[0].data.customerName;
      // console.log('Dashboard didMount card:', results[0].data.card, cardDetails);

      // read widgetic user id
      const widgeticUserId = results[0].data.widgeticUserId;

      // read subscription status
      const subscrStatus = results[0].data.subscriptionStatus;
      // console.log('On Dashboard load subscrStatus:', results[0]);
      // if Subscription expired
      if (subscrStatus === SubscriptionStatus.PAST_DUE) {
        this.props.notify({
          content:
            'We could not auto renew your subscription, please check/update your payment method',
          status: 'error',
        });
      }
      // if Subscription Pending
      else if (subscrStatus === SubscriptionStatus.PENDING) {
        this.props.notify({
          content:
            'We are confirming your payment with the bank, it may take up to 20 minutes. Please refresh this page to fetch latest payment confirmation status',
          status: 'warning',
        });
      }
      // read plan
      const subscrPlan = results[0].data.interval;
      // console.log("Current user's plan:", subscPlan);

      // update the read properties in state
      this.setState({
        widgetMeta: this.props.widgetMeta,
        email: user_email,
        profile: {
          interval: subscrPlan,
          subscriptionStatus: subscrStatus,
          card: cardDetails,
        },
        accountDataLoaded: true,
        loading: false,
      });

      // INTERCOM INTEGRATION
      // intercom setttings script
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.text = `
      window.intercomSettings = {
        api_base: "https://api-iam.intercom.io",
        app_id: "znnltap7",
        name: "${user_full_name}", // User Full name
        email: "${user_email}", // User Email address
        user_id: "${widgeticUserId}", // Widgetic user id
        premium: "${subscrStatus == SubscriptionStatus.ACTIVE}",
        stripe_customer: "${cardDetails.customerId}",
        integration: "wordpress",
        app: "${this.props.widgetMeta.name}", // Widgetic App Name
        domain: "${window.location.hostname}", // Website domain
        site: "${window.location.host}" // Website name
      };
      `;
      document.body.appendChild(script);
      // intercom code script
      const script2 = document.createElement('script');
      script2.type = 'text/javascript';
      script2.text = `(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/znnltap7';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();`;
      document.body.appendChild(script2);

      // OPEN THE STEP from URL params
      let firstStep = this.props.step || 'dashboard'; // console.log('Dashboard did mount step:', firstStep);
      // if not going to dashboard add it in steps array
      if (firstStep != 'dashboard')
        this.setState({ stepsArray: ['dashboard'] });
      // open the param step
      this.goToStep(firstStep);
    } catch (e) {
      // show error of promise
      console.log('plugin backend error:\n', e.toString());

      // prepare backend error message
      const backendStartErrMess = 'Backend fetch error: ';

      // when no composition found show warning
      if (e.code && e.code === 400)
        this.props.notify({
          content: backendStartErrMess + 'No compositions found!',
          status: 'info',
        });
      // when no stripe product found for this widget
      else if (e.code == 'stripe_product_error') {
        this.props.notify({
          content: backendStartErrMess + e.message,
          status: 'error',
        });
      }
      // any other error
      else
        this.props.notify({
          content: 'Backend fetch failed!' + e.toString(),
          status: 'error',
        });

      // hide spinner
      // this.setState({ loading: false });
    }
  }

  /**
   * CARD METHODS
   * **/
  // update card in the database
  async setCard(paymentMethod = null) {
    // console.log("Update card paymentMethod:", paymentMethod);

    // show spinner
    this.setState({ loading: true });

    // get auth token
    const { authToken } = await getAuthToken();
    const headers = { Authorization: `Bearer ${authToken}` };

    // create payload
    const payload = {
      paymentMethod: paymentMethod.id,
      name: paymentMethod.cardHolderName,
    };
    const hasCard = Boolean(
      this.state.profile.card && this.state.profile.card.last4
    );
    if (!hasCard) payload.email = this.state.email;

    // try to add / update card
    try {
      // read the result card
      const method = hasCard ? 'put' : 'post';
      let { data } = await backend[method]('/card', payload, { headers });
      // console.log((hasCard ? 'Update' : 'Add') + ' card result data:', data);

      // if the card was saved properly: show it in dashboard with success notify
      if (data.status === 'ok') {
        // console.log((hasCard ? 'Update' : 'Add') + ' card result data:', data);
        // add holderName to the card object
        if (!data.card) data.card = {};
        data.card.holderName = paymentMethod.cardHolderName;
        console.log((hasCard ? 'Update' : 'Add') + ' card result data:', data);

        // update card in state
        this.setStateCard(data.card);
        // console.log(`State card after ${hasCard ? 'Update' : 'Add'}:`, this.state.profile.card);

        // go to previous step
        this.goBack('Success');
      }

      // if there was an error(usually on updating payment and customer on stripe)
      if (data.status === 'error') {
        // show notification in dashboard
        this.props.notify({
          content: 'Stripe Card error: ' + data.message,
          status: 'error',
        });
      }
    } catch (e) {
      // console.log('Add/Update card error in backend request:', e.message);
      this.props.notify({
        content: `${hasCard ? 'Update' : 'Add'} card backend error: ${
          e.response.data.message
        }. Please try again later.`,
        status: 'error',
      });
    }

    // hide spinner
    this.setState({ loading: false });
  }

  // update state's profile plan
  setStateCard(card = null) {
    this.setState((prevState) => {
      return {
        ...prevState,
        profile: {
          ...prevState.profile,
          card,
        },
      };
    });
  }

  /**
   * COUPON METHODS
   * **/
  async validateCouponCode(couponCode) {
    // console.log('Coupon code:', couponCode);

    // show spinner
    this.setState({ loading: true });

    // get auth Token
    const { authToken } = await getAuthToken();
    const headers = { Authorization: `Bearer ${authToken}` };

    // call validate endpoint
    try {
      const { data } = await backend.get(
        `/validate_coupon?code=${couponCode}`,
        { headers }
      );
      // console.log('validate coupon response:', data);

      if (data.status === 'ok') {
        // go to previous step
        this.goBack();

        // update local coupon code
        this.setState({ coupon: data.data.coupon });

        // hide spinner
        this.setState({ loading: false });
      } else {
        this.props.notify({
          content: 'Invalid coupon code, please try another one.',
          status: 'info',
        });

        // hide spinner
        this.setState({ loading: false });

        return;
      }
    } catch (e) {
      if (e.response.status === 400) {
        this.props.notify({
          content: 'This coupon code seems invalid, please try again',
          status: 'error',
        });
      } else {
        console.error('coupon validation', { e });
        this.props.notify({
          content: 'Something went wrong in the backend, please try again',
          status: 'error',
        });
      }
    }
  }

  /**
   * SUBSCRIPTION METHODS
   * **/
  async subscribe(stripe) {
    // show spinner
    this.setState({ loading: true });

    // get auth Token
    const { authToken } = await getAuthToken();
    const headers = { Authorization: `Bearer ${authToken}` };

    // call subscribe endpoint
    try {
      const { data } = await backend.post(
        '/subscription',
        {
          interval: this.state.selectedPlan,
          coupon: this.state.couponCode,
        },
        { headers }
      );

      // if needs SCA comfirmation show popup
      if (data.status === 'requires_action') {
        // console.log('Subscription intent response:', result);

        // open confirmation popup
        const confirmResult = await stripe.confirmCardPayment(
          data.data.subscription.latest_invoice.payment_intent.client_secret,
          {
            payment_method: this.state.profile.paymentMethodId,
          }
        );

        // show confirmation error
        if (confirmResult.error) {
          // show notification
          // this.props.notify({
          // 	content: 'Authentication failed, please try again',
          // 	status: 'error',
          // });

          // hide spinner
          // this.setState({ loading: false });

          // throw error
          throw confirmResult.error;
        }
        // show account with new subscription
        else {
          // this will force overwrite the premium status
          getAccessToken(true);

          // hide spinner
          this.setState({ loading: false });

          // show that sca confirmation went through
          this.props.notify({
            content:
              'We are confirming your payment with the bank. It may take up to 20 minutes. Please refresh this page to check latest payment status',
            status: 'warning',
          });

          // go home
          this.goToStep('dashboard');
        }
      }
      // show account with new subscription
      else if (data.status === 'ok') {
        // this will force overwrite the premium status
        getAccessToken(true);

        // change subscription status in state
        // console.log('Subscribe result:', data.data.subscription);
        this.setStateSubcrStatus(1);

        // reload list of invoices to show the new one on top
        this.loadInvoices();

        // show Account with the new plan
        this.showPlan(this.state.selectedPlan);
      } else if (data.status === 'card_error') {
        throw {
          message: 'Stripe Error: There was an error paying with your card.',
        };
      }
    } catch (e) {
      // show error if it failed
      console.log('error subscribing', e);

      // show notice with billing error
      if (e.response && e.response.data.statusCode === 402) {
        this.props.notify({
          content: 'Please check your billing details and try again',
          status: 'error',
        });
      }
      // show notice with general error
      else {
        this.props.notify({
          content: e.message,
          status: 'error',
        });
      }

      // hide spinner
      this.setState({ loading: false });
    }
  }

  // update state's profile plan(free or premium)
  setStatePlan(interval = null) {
    this.setState((prevState) => {
      return {
        ...prevState,
        profile: {
          ...prevState.profile,
          interval,
        },
      };
    });
  }

  // update state's subscription status(ACTIVE / PENDING / CANCELED)
  setStateSubcrStatus(status = 0) {
    this.setState((prevState) => {
      return {
        ...prevState,
        profile: {
          ...prevState.profile,
          subscriptionStatus: status,
        },
      };
    });
  }

  // show Account with free / premium plan
  async showPlan(plan = null) {
    // update the plan in the state
    this.setStatePlan(plan);

    // clear current steps list and start from dashboard
    this.setState({ stepsArray: ['dashboard'] });

    // go back to Account with success
    this.goToStep('account', 'Success');

    // hide spinner and remove applied coupon(if there was)
    this.setState({ coupon: null, loading: false });
  }

  async switchToPlan(interval) {
    // check selected plan
    if (
      !(interval === 'month' || interval === 'year') ||
      interval === this.state.selectedPlan
    ) {
      throw new Error('bad interval for updating the plan');
    }

    // get authToken
    const { authToken } = await getAuthToken();
    const headers = { Authorization: `Bearer ${authToken}` };

    // call backend endpoint
    const { data } = await backend.put(
      '/subscription',
      { interval },
      { headers }
    );
    // console.log('switchToPlan response:', data);

    // update the profile's plan in state
    this.setState({ profile: { interval } });
  }

  async deletePlan() {
    // get authToken
    const { authToken } = await getAuthToken();
    const headers = { Authorization: `Bearer ${authToken}` };

    // call subscription delete endpoint
    try {
      const result = await backend.delete('/subscription', { headers });
      const data = result.data;
      // console.log('Canceled subscription:', data);

      // update plan if canceled succesfully
      if (data.status === 'ok') {
        getAccessToken(true);

        // change subscription status in state
        // console.log('UnSubscribe result:', data.data.subscription);
        this.setStateSubcrStatus();

        // show Account with the free plan
        this.showPlan();
      }
      // show error
      else {
        throw result.error;
      }
    } catch (e) {
      // console.log('error subscribing', e);

      // show UI error notification
      this.props.notify({
        content: e.message,
        status: 'error',
      });

      // hide spinner
      this.setState({ loading: false });
    }
  }

  /**
   * NAVIGATION METHODS
   * **/
  async goBack(message = null) {
    // test if can go back
    if (this.state.stepsArray.length < 1) return;

    // clear coupon
    this.setState({ coupon: null });

    // remove last step from array
    this.state.stepsArray.pop();

    // get previous step and remove it too from the list
    const step = this.state.stepsArray[this.state.stepsArray.length - 1];
    this.state.stepsArray.pop();

    // go to previous step in list
    // console.log('goBack to step:', step, this.state.stepsArray);
    this.goToStep(step, message);
  }

  async goToStep(step, message = null) {
    // add the step in the list
    this.state.stepsArray.push(step);

    // set current step
    this.setState({ currentStep: step });
    // console.log('go to step:', step, this.state.stepsArray);

    // show status notification
    if (message) {
      this.props.notify({ content: message, status: 'success' });
    }

    // TODO: add the step to URL params
    // window.location.params.push("step": step);

    // load data for the step
    switch (step) {
      case 'dashboard':
        this.loadPublishedBlocks();
        break;
      case 'account':
        // load prices
        this.loadPrices();

        // load invoices
        this.loadInvoices();
        break;
    }
  }

  // read PUBLISHED BLOCKS(of current logged in user)
  async addCompToBlock(composition) {
    // console.log('Update block with comp:', composition.id, updatedCardIndex);

    // make a copy of the publishedBlocks
    const { publishedComps } = this.state;

    // find index of element with this composition.id
    const updatedCardIndex = findIndex(
      this.state.publishedComps,
      (item) => item.attrs.compId === composition.id
    );
    // console.log('Update block with comp:', composition.id, updatedCardIndex);

    // add composition property to the element
    publishedComps[updatedCardIndex].composition = composition;

    // update state
    this.setState({ publishedComps });

    // using ... operator
    // update that element in the array in state
    // this.state.publishedComps[updatedCardIndex].composition = composition;
    // this.setState((prevState) => ({
    //   publishedComps: {
    //     ...prevState.publishedComps,
    //     [prevState.publishedComps[updatedCardIndex].composition]: composition,
    //   },
    // }));
  }
  async loadPublishedBlocks() {
    // check if not loaded already
    // console.log('current publiched blocks:', this.state.publishedComps.length);
    if (this.state.publishedComps.length) return;

    // show loader
    this.setState({ loading: true });

    // console.log('comps endpoint:', wp.widgeticCompositions());
    let comps = [];
    try {
      comps = await wp.widgeticCompositions();
      // this.setState({ publishedComps: comps });
      // console.log('found comps:', comps);
    } catch (e) {
      console.log('WP error', e);
    }

    // // update the read properties in state
    this.setState({ publishedComps: comps });
    // console.log('this.state.publishedComps:', this.state.publishedComps);

    // hide loader
    this.setState({ loading: false });

    // load composition object for each publishedBlock
    /*comps.map((pBlock) => {
      // pBlock.composition = await this.loadCompostion(pBlock.attrs.compId);
      Widgetic.api('compositions/' + pBlock.attrs.compId)
        .then((composition) => {
          // console.log('Loaded composition:', composition);
          pBlock.composition = composition;
        })
        .fail((error) => {
          // console.log('error reading composition:', error);
          pBlock.composition = {};
        });

      // console.log('pBlock:', pBlock);
      return pBlock;
    });

    // update the read properties in state
    this.setState({ publishedComps: comps });

    console.log('this.state.publishedComps:', this.state.publishedComps);
    */
  }

  async loadPrices() {
    // check if not loaded already
    // console.log('current prices:', this.state.prices.month);
    if (this.state.prices.month) return;
    // console.log('load prices:', this.state.prices.month);
    // show loader
    this.setState({ loading: true });

    // get auth token
    const { authToken } = await getAuthToken();
    const headers = { Authorization: `Bearer ${authToken}` };

    // try to call backend endpoint and read prices from response
    try {
      const result = await backend.get('/prices', { headers });
      // console.log('Prices result:', result);

      let subscrPrices = result.data.data?.prices || {};
      subscrPrices = subscrPrices.data || [
        { unit_amount: 0 },
        { unit_amount: 0 },
      ];
      // console.log('Dashboard didMount plans prices:', subscrPrices);

      // update prices in state
      this.setState({
        prices: {
          month: subscrPrices[0].unit_amount,
          year: subscrPrices[1].unit_amount,
        },
      });
    } catch (e) {
      console.log('error reading prices:', e);
    }

    // hide loader
    this.setState({ loading: false });
  }

  // Load invoices from stripe to show them in Account step
  async loadInvoices() {
    // show loader
    this.setState({ loading: true });

    // get authToken
    const { authToken } = await getAuthToken();
    const headers = { Authorization: `Bearer ${authToken}` };

    // call invoices endpoint
    try {
      const { data } = await backend.get('/invoices', { headers });
      // console.log('Invoices:', data);

      // read invoices
      const invoices = data.data.invoices || [];
      invoices.map((item) => {
        item.paid_at_date = new Date(
          item.status_transitions.paid_at * 1000
        ).toISOString();
        item.paid_at_date = item.paid_at_date.replace('T', ' ');
        item.paid_at_date = item.paid_at_date.replace('.000Z', ' ');
        return item;
      });
      // console.log('Invoices after:', invoices);

      // change list of invoices in state to update it in frontend
      this.setState({ invoices, loading: false });
    } catch (e) {
      console.log('error reading invoices:', e);
      // show UI error notification
      // this.props.notify({
      //   content: e.message,
      //   status: 'error',
      // });
    }

    // hide loader
    this.setState({ loading: false });
  }

  /**
   * RENDER METHOD
   * **/
  render() {
    return (
      <div className='main-holder' style={{ position: 'relative' }}>
        {/* LOADER */}
        {this.state.loading && (
          <div className='spinner-area'>
            <Spinner />
          </div>
        )}

        {/* HEADER with BACK and ACCOUNT/UPGRADE button */}
        {/* BACK button */}
        {this.state.currentStep != 'dashboard' && !this.state.loading && (
          <Button
            className='back-bt'
            style={{
              position: 'absolute',
              height: '60px',
              left: '40px',
              padding: '0px',
              backgroundColor: '#f5f6f9',
            }}
            icon='arrow-left-alt2'
            onClick={() => this.goBack()}
          />
        )}
        {/* ACCOUNT / UPGRADE button */}
        {this.state.currentStep === 'dashboard' &&
          !this.state.loading &&
          this.state.accountDataLoaded && (
            <Button
              style={{
                position: 'absolute',
                top: '48px',
                right: '40px',
              }}
              isPrimary
              onClick={() => this.goToStep('account')}
            >
              {this.state.profile.subscriptionStatus !== 0
                ? 'My Account'
                : 'Upgrade'}
            </Button>
          )}

        {/* COMPOSITIONS STEP */}
        {this.state.currentStep === 'dashboard' && !this.state.loading && (
          <CompositionsList
            widgetName={this.state.widgetMeta.name}
            wp={wp} // for editing the compositions
            content={this.state.publishedComps}
            addCompToBlock={this.addCompToBlock.bind(this)}
          />
        )}

        {/* ACCOUNT STEP */}
        {this.state.currentStep === 'account' && !this.state.loading && (
          <Account
            notify={this.props.notify}
            plan={this.state.profile.interval}
            prices={this.state.prices}
            card={this.state.profile.card}
            invoices={this.state.invoices}
            nextFunction={(step) => this.goToStep(step)}
          />
        )}

        {/* CARD STEP */}
        {this.state.currentStep === 'card' && (
          <Elements stripe={stripePromise}>
            <PaymentForm
              userEmail={this.state.email}
              notify={this.props.notify}
              setCard={this.setCard.bind(this)}
              hasCard={Boolean(
                this.state.profile.card && this.state.profile.card.last4
              )}
            />
          </Elements>
        )}

        {/* PLAN STEP(upgrade or downgrade) */}
        {this.state.currentStep === 'plans' && (
          <>
            {/* UPGRADE STEP */}
            {!this.state.profile.interval && (
              <Flex className='step-holder'>
                <StepTitle>Upgrade to Premium</StepTitle>
                <br />

                {/* Plans toggle */}
                <Flex>
                  <FlexBlock />
                  <RadioGroup
                    onChange={(newPlan) => {
                      this.setState({
                        selectedPlan: newPlan,
                      });
                    }}
                    checked={this.state.selectedPlan}
                  >
                    <Radio className='plan-radio-option' value='month'>
                      Monthly
                    </Radio>
                    <Radio className='plan-radio-option' value='year'>
                      Yearly(save 40%)
                    </Radio>
                  </RadioGroup>
                  <FlexBlock />
                </Flex>

                {/* Plan price */}
                <Flex>
                  <FlexBlock />
                  <h2>
                    ${this.state.prices[this.state.selectedPlan] / 100} /{' '}
                    {this.state.selectedPlan}
                  </h2>
                  <FlexBlock />
                </Flex>

                {/* Plan features */}
                <Flex>
                  <FlexBlock />
                  <FlexBlock>
                    <Flex>
                      <FlexItem>✓</FlexItem>
                      <FlexItem>Unlimited Items</FlexItem>
                      <FlexBlock />
                    </Flex>
                    <Flex>
                      <FlexItem>✓</FlexItem>
                      <FlexItem>No Branding</FlexItem>
                      <FlexBlock />
                    </Flex>
                    <Flex>
                      <FlexItem>✓</FlexItem>
                      <FlexItem>Enhanced Customisation</FlexItem>
                      <FlexBlock />
                    </Flex>
                  </FlexBlock>
                  <FlexBlock />
                </Flex>

                <FlexBlock />

                {/* Submit button */}
                <Flex className='step-footer'>
                  <FlexBlock />
                  <Button
                    isPrimary
                    onClick={() => {
                      // console.log("Subscribe:", this.selectedPlanRef);
                      this.goToStep('order');
                    }}
                  >
                    Select
                  </Button>
                  {/*<Button isPrimary
										onClick={() => {
											this.deletePlan();
											this.goBack();
										}}
									>	
										Switch to {this.state.profile.interval === 'month' ? 'Yearly(save 40%)' : 'Monthly'}
									</Button>*/}
                </Flex>
              </Flex>
            )}

            {/* DOWNGRADE STEP */}
            {this.state.profile.interval && (
              <Flex className='step-holder'>
                <StepTitle>Downgrade to Free?</StepTitle>

                <br />
                <br />
                <br />

                <Flex className='section-title'>
                  You are about to cancel your current subscription
                </Flex>

                <Flex className='section-row'>
                  <FlexItem>
                    {this.state.widgetMeta.name +
                      ' - ' +
                      (this.state.profile.interval === 'month'
                        ? 'Monthly'
                        : 'Yearly') +
                      ' Subscription'}
                  </FlexItem>
                  <FlexItem>
                    ${this.state.prices[this.state.profile.interval] / 100} /{' '}
                    {this.state.profile.interval}
                  </FlexItem>
                </Flex>

                <FlexBlock />

                {/* Submit buttons */}
                <Flex className='step-footer'>
                  <FlexBlock />
                  <Button
                    isSecondary
                    onClick={() => {
                      this.goBack();
                    }}
                  >
                    Nevermind
                  </Button>
                  <Button
                    isDestructive
                    onClick={() => {
                      // show spinner
                      this.setState({ loading: true });

                      // call backend to cancel subscription
                      this.deletePlan();
                    }}
                  >
                    Confirm
                  </Button>
                </Flex>
              </Flex>
            )}
          </>
        )}

        {/* ORDER STEP */}
        {this.state.currentStep === 'order' && (
          <Elements stripe={stripePromise}>
            <Order
              widgetName={this.state.widgetMeta.name}
              plan={{
                text:
                  (this.state.selectedPlan === 'month' ? 'Monthly' : 'Yearly') +
                  ' Subscription',
                price: this.state.prices[this.state.selectedPlan] / 100,
              }}
              card={this.state.profile.card}
              coupon={this.state.coupon}
              cardFunction={() => this.goToStep('card')}
              couponFunction={() => this.goToStep('coupon')}
              finishFunction={(stripe) => this.subscribe(stripe)}
            />
          </Elements>
        )}

        {/* COUPON step */}
        {this.state.currentStep === 'coupon' && (
          <CouponForm
            notify={this.props.notify}
            setCoupon={(couponCode) => this.validateCouponCode(couponCode)}
          />
        )}
      </div>
    );
  }
}

export default Dashboard;
